export default __webpack_public_path__ + "static/logo-973039407dfc61e067042d1108f4fa74.png";